import React from 'react';
import { useLocationsDataReady } from '../hooks/useLocationsDataReady';
import FilterItemList from '../components/FilterItemList';
import FilterModal from '../components/FilterModal';

const Widget = () => {
	const { isReady, error } = useLocationsDataReady();
	if (error) {
		return null;
	}

	return (
		<React.Fragment>
			<div className="d-none d-md-flex">
				<FilterItemList isReady={isReady} />
			</div>
			<FilterModal isReady={isReady} />
		</React.Fragment>
	);
};

export default Widget;
